"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var LargeCheckInput_vue_1 = __importDefault(require("./LargeCheckInput.vue"));
var FormGroup_vue_1 = __importDefault(require("../app/FormGroup.vue"));
var FormInput_vue_1 = __importDefault(require("../app/FormInput.vue"));
var ErrorText_vue_1 = __importDefault(require("../ErrorText.vue"));
exports.default = vue_1.default.extend({
    name: "CocoLinkForm",
    components: { ErrorText: ErrorText_vue_1.default, FormInput: FormInput_vue_1.default, FormGroup: FormGroup_vue_1.default, LargeCheckInput: LargeCheckInput_vue_1.default },
    props: {
        value: {
            type: String,
            default: ""
        },
        errors: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            useCocolink: undefined,
        };
    },
    watch: {
        useCocolink: function (val) {
            if (!val) {
                this.$emit('input', '');
            }
        }
    }
});
